// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__dE6e3","requiredAsterisk":"Info_requiredAsterisk__20Zg4"};